import { combineEpics } from "redux-observable";
import solutionsMainEpic from "./solutionsMainPage/solutionsMain.epic";

const solutionsEpic = combineEpics(solutionsMainEpic);

export default solutionsEpic;
